<template>
  <div>
    <cv-navbar/>
    <div class="setting-main">
      <div class="option">
        <div class="option-item" :class="[item.active ? 'active' : '']" v-for="item in option" :key="item.name" @click="toUrl(item.url)">{{item.name}}</div>
      </div>
      <div class="content">
        <div>
          <div class="privacy_container">
            <div class="privacy_title">
              <div class="title">推荐选项</div>
              <div class="sub_title">开启后将向指定对象推荐您的在线简历</div>
            </div>
            <div class="privacy_content">
              <div class="item mar-t-10">
                <div class="private-left">对企业 HR 推荐</div>
                <div class="private-right">
                  <el-switch
                    v-model="switchOption.recommend_for_hr"
                    active-color="#ff6644"
                    inactive-color="#CFCFCF" @change="setPersonPrivacy">
                  </el-switch>
                </div>
              </div>
              <div class="item">
                <div class="private-left">对校友/前同事关系推荐</div>
                <div class="private-right">
                  <el-switch
                    v-model="switchOption.recommend_for_classmate"
                    active-color="#ff6644"
                    inactive-color="#CFCFCF" @change="setPersonPrivacy">
                  </el-switch>
                </div>
              </div>
              <div class="item">
                <div class="private-left">对有内推资源者推荐</div>
                <div class="private-right">
                  <el-switch
                    v-model="switchOption.recommend_for_internal"
                    active-color="#ff6644"
                    inactive-color="#CFCFCF" @change="setPersonPrivacy">
                  </el-switch>
                </div>
              </div>
            </div>
          </div>
          <div :class="['privacy_container', list.length > 0 ? 'pad-b-0' : 'border-other-radius']">
            <div class="privacy_title">
              <div class="title">屏蔽选项</div>
              <div class="sub_title">开启后屏蔽对象将无法查看到您的在线简历</div>
            </div>
            <div class="privacy_content">
<!--              <div class="item mar-t-10">-->
<!--                <div class="private-left">对当前在职公司屏蔽</div>-->
<!--                <div class="private-right">-->
<!--                  <el-switch-->
<!--                    v-model="switchOption.recommend_for_hr"-->
<!--                    active-color="#ff6644"-->
<!--                    inactive-color="#CFCFCF">-->
<!--                  </el-switch>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="private-left">对过往公司屏蔽</div>-->
<!--                <div class="private-right">-->
<!--                  <el-switch-->
<!--                    v-model="switchOption.recommend_for_classmate"-->
<!--                    active-color="#ff6644"-->
<!--                    inactive-color="#CFCFCF">-->
<!--                  </el-switch>-->
<!--                </div>-->
<!--              </div>-->
              <div class="item">
                <div class="private-left">对其他公司屏蔽</div>
                <div class="private-right">
                  <div class="company-add" @click="showAddCompany = true;"><i class="iconfont iconplus-circle"></i>添加屏蔽公司</div>
                </div>
              </div>
            </div>
          </div>
          <div class="company-list" v-show="list.length > 0">
            <div class="company-item" v-for="(item, index) in list" :key="index">
              <span>{{item.company_name}}</span>
              <span class="company-close" @click="closeCompany(item)">取消屏蔽</span>
            </div>
          </div>
          <div class="privacy_container">
            <div class="privacy_title">
              <div class="title">曝光选项</div>
              <div class="sub_title">开启后将向指定对象推荐您的在线简历</div>
            </div>
            <div class="privacy_content">
              <div class="item mar-t-10 item_sub">
                <div class="private-left-sub">
                  <span>加强曝光</span>
                  <span class="desc">优先推荐你的简历，限时免费</span>
                </div>
                <div class="private-right">
                  <el-switch
                    v-model="switchOption.increase_exposure"
                    active-color="#ff6644"
                    inactive-color="#CFCFCF" @change="setPersonPrivacy">
                  </el-switch>
                </div>
              </div>
              <div class="item item_sub">
                <div class="private-left-sub">
                  <span>直接联系</span>
                  <span class="desc">认证的 HR /推荐人可在发起邀请后获得你的电话号码</span>
                </div>
                <div class="private-right">
                  <el-switch
                    v-model="switchOption.contact_directly"
                    active-color="#ff6644"
                    inactive-color="#CFCFCF" @change="setPersonPrivacy">
                  </el-switch>
                </div>
              </div>
              <div class="item item_sub">
                <div class="private-left-sub">
                  <span>站内联系</span>
                  <span class="desc">只允许HR通过站内信联系我，不能电话联系我</span>
                </div>
                <div class="private-right">
                  <el-switch
                    v-model="switchOption.contact_insite"
                    active-color="#ff6644"
                    inactive-color="#CFCFCF" @change="setPersonPrivacy">
                  </el-switch>
                </div>
              </div>
            </div>
          </div>
<!--          <div class="private" v-if="visibilityShow">-->
<!--            <div class="private-left">-->
<!--              <p>对 HR 隐藏简历</p>-->
<!--              <p class="msg">隐藏后 HR 将无法搜索到你的简历</p>-->
<!--            </div>-->
<!--            <div class="private-right" :class="[cv_invisibile ? 'active' : '']" @click="setPrivacy"><span></span></div>-->
<!--          </div>-->
<!--          <div class="company">-->
<!--            <div class="company-title">-->
<!--              <div class="company-name">-->
<!--                <div>屏蔽公司</div>-->
<!--                <div class="company-add" @click="showAddCompany = true;"><i class="iconfont iconplus-circle"></i>添加屏蔽公司</div>-->
<!--              </div>-->
<!--              <div class="company-msg">屏蔽后，该公司的所有HR将无法通过简历推荐、人才搜索等看见你的简历</div>-->
<!--            </div>-->
<!--            <div class="company-list">-->
<!--              <div class="company-item" v-for="(item, index) in list" :key="index">-->
<!--                <span>{{item.company_name}}</span>-->
<!--                <span class="company-close" @click="closeCompany(item)">取消屏蔽</span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <AddCompany
      :show="showAddCompany"
      @update="showAddCompany = false;getBlockingCompanies()"
      @close="showAddCompany = false;"/>
  </div>
</template>
<script>
import cvNavbar from '@/components/base/navbar';
import AddCompany from './components/addCompany'
import api from '@/api';
import { get_tUser, dealSignatrue, routerTo } from '@/assets/js/util';
export default {
  name: 'Setting',
  components: {
    cvNavbar,
    AddCompany
  },
  data() {
    return {
      switchOption: {
        recommend_for_hr: false,   // 对企业HR推荐
        recommend_for_classmate: false, // 对校友/前同事推荐
        recommend_for_internal: false,   // 对有内推资源者推荐
        increase_exposure: false, // 加强曝光
        contact_directly: false,   // 	直接联系
        contact_insite: false   // 站内联系
      },
      option: [
        {
          name: '基本信息',
          url: '/account/users?type=info',
          active: false
        },
        {
          name:'账号设置',
          url:'/account/settings',
          active: false
        },
        {
          name: '隐私设置',
          url: '',
          active: true
        },
       /*  {
          name: '优惠活动',
          url: '/account/users/current',
          active: false
        }, */
        {
          name: '我的订单',
          url: '/account/orders',
          active: false
        }
      ],
      _c_t: '',
      cv_invisibile: false,
      onlineCv: {},
      visibilityShow: true,
      showAddCompany: false, // 显示添加公司弹窗
      list: []
    };
  },
  async created() {
    this.$store.commit('app/IS_DOUBLE', true);
    this._c_t = get_tUser().c_t || '';
    try {
      // 获取在线简历
      await this.getOnlineCv();
      this.getBlockingCompanies();
      this.getPersonPrivacy();
      // 获取简历四密度
      let res = await api.cvsV2.cvVisibility(this._c_t);
      this.cv_invisibile = res.data.cv_invisibile || false;
    } catch(err) {
      console.error(err);
    }
  },
  methods: {
    // 获取隐私设置
    async getPersonPrivacy() {
      try {
        let res = await api.account.getPersonPrivacy(this._c_t);
        if (res.code === 1000) {
          console.log(res.data,"=====>privacy");
          this.switchOption = res.data
        } else {
          this.$message.error(res.message);
        }
      } catch (e) {
        console.error(e);
      }
    },
    // 设置隐私设置
    async setPersonPrivacy() {
      try {
        let res = await api.account.setPersonPrivacy(this._c_t, this.switchOption);
        if (res.code === 1000) {
          this.switchOption = res.data
        } else {
          this.$message.error(res.message);
        }
      } catch (e) {
        console.error(e);
      }
    },
    // 屏蔽公司列表
    async getBlockingCompanies() {
      try {
        let res = await api.company.blockingCompanies();
        this.list = (res.data && res.data.blocking_companies) || [];
      } catch (e) {
        console.error(e);
      }
    },
    async closeCompany(data) {
      try {
        let res = await api.company.closeBlockingCompanies(data.token);
        if (res.code === 1000) {
          this.getBlockingCompanies();
          this.$message.success('取消成功');
        }
        else {
          this.$message.error('取消失败');
        }
      } catch (e) {
        console.error(e);
      }
    },
    // 获取在线简历
    async getOnlineCv() {
      try {
        let res = await api.cvsV2.getOnlineCv(this._c_t);
        this.visibilityShow = res.code !== 80120
      } catch (e) {
        console.error(e);
      }
    },
    // 设置私密度
    async setPrivacy() {
      try {
        let res = await api.cvsV2.setCvVisibility(this._c_t, { cv_invisibile: !this.cv_invisibile });
        if (res.code === 1000 ) {
          // this.$message.success('更新成功');
          this.cv_invisibile = !this.cv_invisibile;
        }
        else {
          // this.$message.error('更新失败');
        }
      } catch (e) {
        console.error(e);
      }
    },
    toUrl(url) {
      console.log(url,"=====>url");
      // this.$router.push(url)
      routerTo(url);
    }
  },
}
</script>
<style lang="scss" scoped>
  .mar-t-10{
    margin-top: 10px;
  }
  .pad-b-0 {
    padding-bottom: 0!important;
  }
  .setting-main {
    width: 1116px;
    margin: 80px auto 0;
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
    * {
      box-sizing: border-box;
    }
    .option {
      width: 260px;
      height: 448px;
      border-radius: 2px;
      overflow: hidden;
      box-shadow: 0px 2px 4px 0px rgba(1, 35, 99, 0.04);
      .option-item {
        height: 112px;
        position: relative;
        cursor: pointer;
        background: #fff;
        text-align: center;
        line-height: 110px;
        font-size: 16px;
        color: #606060;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        &.active {
          color: #404040;
          &::before {
            content: "";
            display: block;
            width: 8px;
            height: 26px;
            background: #FF4F4C;
            position: absolute;
            top: 50%;
            left: 56px;
            margin-top: -13px;
          }
        }
        &::after {
          content: "";
          display: block;
          width: 238px;
          height: 1px;
          background: #F5F5F7;
          position: absolute;
          left: 11px;
          bottom: 0;
        }
        &:last-child::after {
          height: 0;
        }
      }
    }
    .content {
      width: 832px;
      .border-other-radius {
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
      }
      .privacy_container {
        width: 100%;
        height: auto;
        padding: 30px 40px;
        box-sizing: border-box;
        background-color: #fff;
        margin-top: 16px;
        //border-radius: 2px;
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
        box-shadow: 0px 2px 4px 0px rgba(1, 35, 99, 0.04);
        &:first-child {
          margin-top: 0;
        }
        .privacy_title {
          padding-bottom: 20px;
          .title{
            font-size: 16px;
            color: #333;
            font-weight: 500;
          }
          .sub_title {
            margin-top: 12px;
            font-size: 12px;
            color: #9c9c9c;
          }
        }
        .privacy_content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          border-top: 1px solid #F5F5F7;
          .item {
            width: 100%;
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .private-left {
              font-size: 14px;
              color: #404040;
            }
            .private-left-sub {
              height: 38px;
              font-size: 14px;
              color: #404040;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .desc{
                font-size: 12px;
                color: #9c9c9c;
              }
            }
            .private-right {
              .company-add{
                color: #ff6644;
                cursor: pointer;
              }
              ::v-deep .el-switch {
                width: 48px !important;
                height: 22px;
                .el-switch__core{
                  width: 100% !important;
                  height: 100%;
                  &:after{
                    width: 18px;
                    height: 18px;
                  }
                }
              }
              ::v-deep .el-switch.is-checked {
                .el-switch__core{
                  &:after{
                    margin-left: -19px!important;
                  }
                }
              }
            }
          }
          .item_sub {
            height: 62px;
          }
        }
      }
      .private {
        height: 100px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 40px;
        .private-left {
          font-size: 16px;
          color: #404040;
          .msg {
            font-size: 12px;
            color: #9C9C9C;
            margin-top: 8px;
          }
        }
        .private-right {
          width: 48px;
          height: 22px;
          border-radius: 11px;
          background: #CFCFCF;
          padding: 2px;
          cursor: pointer;
          span {
            display: block;
            width: 18px;
            height: 18px;
            background: #fff;
            border-radius: 9px;
            transition: all .3s ease;
          }
          &.active {
            background: #FF4F4C;
            span {
              float: right;
            }
          }
        }
      }
      .company-list {
        width: 832px;
        height: auto;
        padding-bottom: 30px;
        background-color: #fff;
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
        .company-item {
          width: 100%;
          height: 42px;
          //background-color: #ececec;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;
          padding: 0 40px;
          font-size: 14px;
          color: #9c9c9c;
          .company-close {
            color: #ff6644;
            cursor: pointer;
          }
          &:hover{
            background-color: #F9F9F9;
          }
        }
      }
      //.company {
      //  height: 450px;
      //  background: #fff;
      //  margin-top: 10px;
      //  padding: 30px 0px;
      //  .company-title {
      //    padding: 0 40px;
      //  }
      //  .company-name {
      //    color: rgba(64, 64, 64, 1);
      //    font-size: 16px;
      //    display: flex;
      //    align-items: center;
      //    justify-content: space-between;
      //    .company-add {
      //      color: rgba(255, 79, 76, 1);
      //      font-size: 14px;
      //      cursor: pointer;
      //      .iconfont {
      //        font-weight: 600;
      //        margin-right: 2px;
      //      }
      //      &:hover {
      //        color: rgba(255, 79, 76, .8);
      //      }
      //    }
      //  }
      //  .company-msg {
      //    color: rgba(156, 156, 156, 1);
      //    font-size: 12px;
      //    margin-top: 12px;
      //  }
      //  .company-list {
      //    height: 370px;
      //    margin-top: 8px;
      //    overflow: auto;
      //    .company-item {
      //      padding: 0 40px;
      //      height: 42px;
      //      line-height: 42px;
      //      display: flex;
      //      align-items: center;
      //      justify-content: space-between;
      //      font-size: 14px;
      //      color: rgba(64, 64, 64, 1);
      //      &:hover {
      //        background: rgba(249, 249, 249, 1);
      //        .company-close {
      //          display: block;
      //        }
      //      }
      //      .company-close {
      //        display: none;
      //        cursor: pointer;
      //        color: rgba(255, 79, 76, 1);
      //        font-size: 14px;
      //      }
      //    }
      //  }
      //}
    }
  }
</style>
